const burgerButton = document.querySelector('#burgerButton')
const menuContainer = document.querySelector('#navMobileContainer')
const menuTitle = document.querySelector('.nav-menu-title')

const cover = document.querySelector('.cover')

const toggleMenu = () => {
	burgerButtonsSpans = burgerButton.querySelectorAll('span')
	burgerButtonsSpans.forEach(span => {
		span.classList.toggle('is-active')
	})
	menuContainer.classList.toggle('!left-0')
	cover.classList.toggle('w-full')
}
cover.addEventListener('click', e => {
	const isOutside = !e.target.closest('.navMobileContainer')
	if (isOutside) {
		toggleMenu()
	}
})

burgerButton.addEventListener('click', toggleMenu)
// handle menu
const changeMenuTitle = liName => {
	menuTitle.innerHTML = liName.innerHTML
}
const mobileListItems = menuContainer.querySelectorAll('.nav-list-mobile li')
const mobileListLinks = menuContainer.querySelectorAll('.nav-list-mobile li a')

const mobileListLinksNoHref = Array.from(mobileListLinks).filter(item => {
	return !item.href
})

let nextIconsReady
let prevIconsReady

const checkListItems = () => {
	mobileListItems.forEach(item => {
		const listWrapper = item.querySelector('ul')

		if (listWrapper !== null && listWrapper.offsetParent !== null) {
			if (listWrapper.scrollHeight <= listWrapper.offsetParent.scrollHeight) {
				listWrapper.style.minHeight = listWrapper.offsetParent.scrollHeight + 'px'
			}
			const slideIconNext = document.createElement('button')
			slideIconNext.classList.add(
				'nav-button-next',
				'flex',
				'items-center',
				'justify-center',
				'z-10',
				'bg-transparent',
				'h-full',
				'w-6',
				'basis-1/5',
				'border-l',
				'border-solid',
				'border-royalPurple'
			)
			slideIconNext.innerHTML =
				"<img src='/wp-content/themes/MinisterstwoReklamy/images/icons/right-arrow.svg' class='active:scale-125 duration-300 max-w-[15px] !h-auto'>"

			const slideIconPrev = document.createElement('button')
			slideIconPrev.classList.add(
				'flex',
				'items-center',
				'justify-center',
				'z-10',
				'bg-transparent',
				'nav-button-prev',
				'h-12',
				'w-full',
				'border-y',
				'border-solid',
				'border-royalPurple'
			)
			slideIconPrev.innerHTML =
				"<img src='/wp-content/themes/MinisterstwoReklamy/images/icons/left-arrow.svg' class='active:scale-125 duration-100 nav__icon nav__icon--next  max-w-[15px] !h-auto'> "

			item.querySelector('ul').prepend(slideIconPrev)
			item.appendChild(slideIconNext)
		}
	})
}

const prepareIconsReady = () => {
	nextIconsReady = document.querySelectorAll('.nav-button-next')
	prevIconsReady = menuContainer.querySelectorAll('.nav-button-prev')
}
checkListItems()
prepareIconsReady()

nextIconsReady.forEach(icon => {
	icon.addEventListener('click', () => {
		icon.parentElement.children[1].classList.remove('translate-x-full')
		changeMenuTitle(icon.parentElement.children[0])
	})
})
mobileListLinksNoHref.forEach(item => {
	item.addEventListener('click', () => {
		item.parentElement.children[1].classList.remove('translate-x-full')
		changeMenuTitle(item)
	})
})
prevIconsReady.forEach(icon => {
	icon.addEventListener('click', () => {
		icon.parentElement.classList.add('translate-x-full')

		if (
			!icon.parentElement.parentElement.parentElement.parentElement.children[1].classList.contains('nav-menu-title')
		) {
			changeMenuTitle(icon.parentElement.parentElement.parentElement.parentElement.children[0])
		} else {
			menuTitle.innerHTML = 'Menu'
		}
	})
})
